// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1psvQ","bigColWidth":"Table_bigColWidth__3OrNF","biggerColWidth":"Table_biggerColWidth__1FHRj","row":"Table_row__2N3lR","col":"Table_col__3og4g"};